"use client";

import { useRouter } from "next/navigation";
import { useTransition } from "react";
import { DISPLAY_CURRENCY_COOKIE } from "@/lib/tenant/currency-cookie";

export interface CurrencyChoice {
	code: string;
	label: string;
}

// Lets a customer pick the display currency. Persists the choice in a cookie
// and refreshes so server components re-price everything via the rate table.
export function CurrencySwitcher({
	choices,
	current,
}: {
	choices: CurrencyChoice[];
	current: string;
}) {
	const router = useRouter();
	const [isPending, startTransition] = useTransition();

	if (choices.length <= 1) return null;

	function select(code: string) {
		document.cookie = `${DISPLAY_CURRENCY_COOKIE}=${code}; path=/; max-age=${60 * 60 * 24 * 365}; samesite=lax`;
		startTransition(() => router.refresh());
	}

	return (
		<select
			aria-label="currency"
			value={current}
			disabled={isPending}
			onChange={(e) => select(e.target.value)}
			className="h-9 rounded-lg border border-border bg-surface px-2 text-sm outline-none transition focus:border-primary"
		>
			{choices.map((c) => (
				<option key={c.code} value={c.code}>
					{c.label}
				</option>
			))}
		</select>
	);
}
